// ============================================
// i18n — Қазақша
// ============================================

export const kk = {
  // Общие
  app_name: 'Samsa',
  next: 'Ары →',
  back: '← Артқа',
  cancel: 'Болдырмау',
  save: 'Сақтау',
  delete: 'Жою',
  add: 'Қосу',
  edit: 'Өңдеу',
  loading: 'Жүктелуде...',
  error: 'Қате',
  success: 'Дайын!',

  // Навигация
  step: '{current} / {total} қадам',

  // Шаг 1 — Основная информация
  step1_title: 'Негізгі ақпарат',
  business_name: 'Бизнес атауы',
  business_name_placeholder: 'Менің салоным',
  business_description: 'Сипаттама',
  business_description_placeholder: 'Астанадағы үздік салон',
  phone: 'Телефон',
  phone_placeholder: '+7 777 123 45 67',
  whatsapp: 'WhatsApp',
  whatsapp_placeholder: '77771234567',
  instagram: 'Instagram',
  instagram_placeholder: 'my_salon',
  address: 'Мекенжай',
  address_placeholder: 'Астана, Пушкин көш. 10',
  work_hours: 'Жұмыс уақыты',
  work_hours_placeholder: 'Дс-Сб 9:00-20:00',

  // Шаг 2 — Страна и город
  step2_title: 'Ел және қала',
  country: 'Ел',
  city: 'Қала',
  country_kz: 'Қазақстан',
  country_ru: 'Ресей',
  country_uz: 'Өзбекстан',
  country_kg: 'Қырғызстан',
  city_astana: 'Астана',
  city_almaty: 'Алматы',
  city_shymkent: 'Шымкент',
  city_karaganda: 'Қарағанды',
  city_aktau: 'Ақтау',
  city_atyrau: 'Атырау',
  city_pavlodar: 'Павлодар',
  city_uryzhar: 'Өскемен',
  city_other: 'Басқа',

  // Шаг 3 — Товары/Услуги
  step3_title: 'Тауарлар және қызметтер',
  add_item: '+ Тауар/қызмет қосу',
  item_name: 'Атауы',
  item_name_placeholder: 'Ерлер шаш үлгісі',
  item_price: 'Бағасы',
  item_price_placeholder: '3 000 ₸',
  item_description: 'Сипаттама (міндетті емес)',

  // Шаг 4 — Цвет и стиль
  step4_title: 'Түс және стиль',
  color_scheme: 'Түс схемасы',
  template: 'Шаблон',
  template_minimal: 'Минималды',
  template_bright: 'Жарқын',
  custom_color: 'Өз түсіңіз',

  // Шаг 5 — Предпросмотр и оплата
  step5_title: 'Алдын ала қарау',
  preview: 'Лендинг алдын ала қарау',
  price: 'Құны',
  price_tenge: '1 990 ₸',
  pay_button: '⭐ Төлеу және жасау',
  promocode_label: 'Промокод бар ма?',
  promocode_placeholder: 'Промокод енгізіңіз',
  promocode_check: 'Тексеру',
  promocode_valid: '✅ Промокод жарамды! Қалды: {remaining}',
  promocode_invalid: '❌ {reason}',
  use_promocode: 'Промокод қолдану',

  // Мои лендинги
  my_landings: 'Менің лендингтерім',
  no_landings: 'Сізде әлі лендинг жоқ',
  create_first: 'Бірінші жасау',
  status_active: 'Белсенді',
  status_draft: 'Жоба',
  status_disabled: 'Өшірілген',

  // Сообщения
  draft_saved: 'Жоба сақталды',
  payment_success: 'Төлем өтті! Лендинг жасалуда...',
  payment_failed: 'Төлем қатесі. Қайталап көріңіз.',
  limit_reached: 'Күндік лимит толды. Ертең көріңіз.',

  // Цвета
  color_blue: 'Көк',
  color_green: 'Жасыл',
  color_dark: 'Қараңғы',
  color_light: 'Жарық',
  color_red: 'Қызыл',
  color_purple: 'Күлгін',
};
